export default {
    grey: '#434445',
    lightGrey: '#ABA4AD',
    blue: '#32C5FF',
    green: '#6DD400',
    black: '#141712',
    pink: '#FE116D',
    red: '#FF0000'
}
